import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_COLOR_HERO_TITLE, PDF_FONTS } from '../pdfTypography';

const styles = StyleSheet.create({
  container: {
    marginBottom: 26,
  },
  title: {
    fontSize: PDF_FONTS.heroTitle,
    fontWeight: 'bold',
    color: PDF_COLOR_HERO_TITLE,
    lineHeight: 1.08,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: PDF_FONTS.heroSubtitle,
    fontWeight: 'bold',
    color: '#000000',
    lineHeight: 1.12,
  },
});

interface CoverTitleProps {
  title: string;
  subtitle: string;
}

const CoverTitle: React.FC<CoverTitleProps> = ({ title, subtitle }) => (
  <View style={styles.container}>
    <Text style={styles.title}>{title}</Text>
    <Text style={styles.subtitle}>{subtitle}</Text>
  </View>
);

export default CoverTitle;
